import { useController } from 'react-hook-form';
import {
  UniversalSingleSelect,
  UniversalSingleSelectProps
} from './UniversalSingleSelect';

export const UniversalSingleSelectWithRHF: React.FC<
  UniversalSingleSelectProps & { formId: string }
> = props => {
  const { field } = useController({ name: props.formId });

  return (
    <UniversalSingleSelect
      {...props}
      value={field.value ?? null}
      onChange={newValue => field.onChange(newValue)}
      disabled={props.disabled}
    />
  );
};
